import { Flex, theme } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const PropertyGridStickyColumnHeader = ({ children }: PropsWithChildren) => (
  <Flex
    flexDirection="column"
    position="sticky"
    top="0"
    zIndex={theme.zIndices.sticky}
    backgroundColor="surface1"
    width="100%"
    flexShrink={0}
    __testId="property-grid-sticky-column-header"
  >
    {children}
  </Flex>
);
